// extracted by mini-css-extract-plugin
export default {"sliderTrack":"PriceSlider_sliderTrack__5Q63A","sliderThumb":"PriceSlider_sliderThumb__QUbSD"};